<template>
    <div :style="{fontSize:fSize+'px'}">
        <slot></slot>
    </div>
</template>

<script>

    let defaultWidth = 375,
        defaultFont = 16,
        minWidth = 375,
        minHeight = 812,
        defaultHeight = 812;

    export default {
        name: 'Resize',
        mounted () {
            window.addEventListener('resize',this.onResize.bind(this));

            this.$root.$emit('onResize',{vW:this.vW,vH:this.vH});
            if (this.isMobile()) {
                document.documentElement.classList.add('mobile');
                document.documentElement.classList.remove('desktop');
            } else {
                document.documentElement.classList.remove('mobile');
                document.documentElement.classList.add('desktop');
            }
        },
        data () {
            return {
                vW:  window.innerWidth,
                vH:  window.innerHeight
            }
        },

        computed: {
            fSize () {
                let vW = this.vW;
                let vH = this.vH;
                return this.isMobile() ? 16 : 16*Math.min(Math.max(minWidth,vW)/defaultWidth,Math.max(minHeight,vH)/defaultHeight);
            }
        },
        methods: {
            onResize () {
                this.vW = window.innerWidth;
                this.vH = window.innerHeight;

                this.$root.$emit('onResize',{vW:this.vW,vH:this.vH});

                if (this.isMobile()) {
                    document.documentElement.classList.add('mobile');
                    document.documentElement.classList.remove('desktop');
                } else {
                    document.documentElement.classList.remove('mobile');
                    document.documentElement.classList.add('desktop');
                }
            },
            isMobile() {
                return this.$root.Helpers.isMobile();
            }
        }

    }
</script>



// WEBPACK FOOTER //
// Resize.vue?7dd05abc